import { phoneNumberForVerificationFromInput } from '../../../form-controls/PhoneNumberInput/phoneNumberUtils';

const MOBILE_OTP_RESEND_LIMITER_PREFIX = 'otpResendLimiter_mobile';
const EMAIL_OTP_RESEND_LIMITER_PREFIX = 'otpResendLimiter_email';

function normaliseEmailForLimiterKey(email: string): string {
  return email.trim().toLowerCase();
}

function normalisePhoneForLimiterKey(phoneVerificationValue: string): string {
  return phoneVerificationValue.replace(/\D/g, '');
}

function getMobileOtpResendLimiterStorageKey(prefix: string, nationalNumber: string): string {
  const phoneVerificationValue = phoneNumberForVerificationFromInput(prefix, nationalNumber);
  const normalised = normalisePhoneForLimiterKey(phoneVerificationValue);

  return normalised ? `${MOBILE_OTP_RESEND_LIMITER_PREFIX}_${normalised}` : MOBILE_OTP_RESEND_LIMITER_PREFIX;
}

function getEmailOtpResendLimiterStorageKey(email: string): string {
  const normalised = normaliseEmailForLimiterKey(email);

  return normalised ? `${EMAIL_OTP_RESEND_LIMITER_PREFIX}_${normalised}` : EMAIL_OTP_RESEND_LIMITER_PREFIX;
}

function clearOtpResendLimitersWithPrefix(prefix: string): void {
  if (typeof localStorage === 'undefined') {
    return;
  }

  for (let index = localStorage.length - 1; index >= 0; index -= 1) {
    const key = localStorage.key(index);

    if (key?.startsWith(prefix)) {
      localStorage.removeItem(key);
    }
  }
}

function clearMobileOtpResendLimiters(): void {
  clearOtpResendLimitersWithPrefix(MOBILE_OTP_RESEND_LIMITER_PREFIX);
}

function clearEmailOtpResendLimiters(): void {
  clearOtpResendLimitersWithPrefix(EMAIL_OTP_RESEND_LIMITER_PREFIX);
}

export {
  clearEmailOtpResendLimiters,
  clearMobileOtpResendLimiters,
  EMAIL_OTP_RESEND_LIMITER_PREFIX,
  getEmailOtpResendLimiterStorageKey,
  getMobileOtpResendLimiterStorageKey,
  MOBILE_OTP_RESEND_LIMITER_PREFIX,
};
